import AllPhrasesIndex from "AllPhrasesIndex";
import BookModel from "models/BookModel";
import PrivateBookTagsCollection from "models/PrivateBookTagsCollection";
import RemoteUserWordsCollection from "models/RemoteUserWordsCollection";
import ShelvesCollection from "models/ShelvesCollection";
import StoredNotificationsModel from "models/StoredNotificationsModel";
import StreakModel from "models/StreakModel";
import UserModel from "models/UserModel";
import UserWordsCollection from "models/UserWordsCollection";
import FlashcardSessionModel from "./FlashcardSessionModel";

const user = new UserModel();

const remoteUserWordsFactory = () => {
  const remoteUserWords = new RemoteUserWordsCollection([], { user });

  // connect to all phrase index
  remoteUserWords.on("add", (model) => {
    models.allPhrasesIndex.addToPhraseIndex(
      model.get("language"),
      model.get("word")
    );
  });
  remoteUserWords.on("remove", (model) => {
    models.allPhrasesIndex.removeFromPhraseIndex(
      model.get("language"),
      model.get("word")
    );
  });
  remoteUserWords.on("change:word", (model) => {
    models.allPhrasesIndex.removeFromPhraseIndex(
      model.get("language"),
      model.previous("word")
    );
    models.allPhrasesIndex.addToPhraseIndex(
      model.get("language"),
      model.get("word")
    );
  });
  remoteUserWords.on("change:recalledThisSession", (model) => {
    models.allPhrasesIndex.wordRecalled(
      model.get("language"),
      model.get("word")
    );
  });

  // reset models.userWords groups on each change
  remoteUserWords.on("add remove change", () => {
    models.userWords.resetGroups();
  });

  return remoteUserWords;
};

// Backbone models
const models: {
  user: UserModel;
  userWords: UserWordsCollection;
  allPhrasesIndex: AllPhrasesIndex;
  bookTags: typeof PrivateBookTagsCollection;
  shelves: typeof ShelvesCollection;
  streak: StreakModel;
  storedNotifications: StoredNotificationsModel;
  remoteUserWordsFactory: () => typeof RemoteUserWordsCollection;
  remoteUserWords: typeof RemoteUserWordsCollection;
  bookModel?: BookModel;
  flashcardSession?: typeof FlashcardSessionModel;
} = {
  user,
  userWords: new UserWordsCollection([], { user }),
  allPhrasesIndex: new AllPhrasesIndex(),
  bookTags: new PrivateBookTagsCollection(),
  shelves: new ShelvesCollection(),
  streak: new StreakModel(),
  storedNotifications: new StoredNotificationsModel(),
  remoteUserWordsFactory,
  remoteUserWords: remoteUserWordsFactory(),
};

models.streak.on("change:todayStats", async () => {
  const todayStats = models.streak.get("todayStats");
  if (todayStats?.goalMet) {
    // Clear the stored notifications upon meeting the daily goal
    models.storedNotifications.deleteAllStoredNotifications();
  }
});

window["models"] = models;
export default models;
